module.exports = __webpack_public_path__ + "static/img/NichoHynes.8aff72c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NichoHynes.jpg
// module id = 1nG1
// module chunks = 0